import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ConnectionStatus, IMovementTerminal, IRealtimeState } from "./types"

const initialState: IRealtimeState = {
  connectionStatus: "disconnected",
  lastError: null,
  movementTerminal: null
}

const realtimeSlice = createSlice({
  name: "realtime",
  initialState,
  reducers: {
    setConnectionStatus: (state, action: PayloadAction<ConnectionStatus>) => {
      state.connectionStatus = action.payload
      if (action.payload === "connected") {
        state.lastError = null
      }
    },
    setRealtimeError: (state, action: PayloadAction<string | null>) => {
      state.lastError = action.payload
    },
    setMovementTerminal: (state, action: PayloadAction<IMovementTerminal>) => {
      state.movementTerminal = action.payload
    },
    clearMovementTerminal: (state) => {
      state.movementTerminal = null
    }
  }
})

export const {
  setConnectionStatus,
  setRealtimeError,
  setMovementTerminal,
  clearMovementTerminal
} = realtimeSlice.actions
export const realtimeReducer = realtimeSlice.reducer
